module.exports = __webpack_public_path__ + "static/img/abHonor.a23588f6.png";